import React from 'react';
import { Field } from 'react-final-form';
import { FormFieldProps } from 'types/TextField';
import { InputFileProps } from 'types/InputFile';
import InputFile from '../InputFile';

function FormInputFile( {
  field,
  ...rest
}: InputFileProps & FormFieldProps ) {
  return (
    <Field
      name={field as string}
      render={( { input, meta } ) => {
        const isInvalid = ( meta.touched && !!meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );
        return (
          <InputFile
            value={input.value}
            meta={meta}
            onChange={( newValue ) => {
              input.onChange( newValue );
            }}
            isInvalid={isInvalid}
            {...rest}
          />
        );
      }}
    />
  );
}

export default FormInputFile;
